import {sendDataLayerEvent} from '../util/analytics';
import {createHubSpotNewsletterForm} from '../util/hubspot-form';

const EXIT_INTENT_COOKIE_NAME = 'exitIntentShown';
const NEWSLETTER_FORM_POPUP_ID = '98784659-77bb-4dfb-8102-030014942dee';

const onExit = e => {
  const shouldExit =
    [...e.target.classList].includes('exit-modal') || // user clicks on mask
    e.target.className === 'exit-modal__close-button' || // user clicks on the close icon
    e.keyCode === 27; // user hits escape

  if (shouldExit) {
    document.querySelector('.exit-modal').classList.remove('exit-model--visible');
    document.body.classList.remove('non-scrollable');
  }
};

const onMouseEvent = e => {
  const shouldShowExitIntent = !e.toElement && !e.relatedTarget && e.clientY < 10;

  if (shouldShowExitIntent) {
    document.removeEventListener('mouseout', onMouseEvent);
    document.querySelector('.exit-modal').classList.add('exit-model--visible');

    createHubSpotNewsletterForm(
      NEWSLETTER_FORM_POPUP_ID,
      '.exit-modal__form',
      'btn btn--secondary',
      () => sendDataLayerEvent('exitIntentPopupSubmitted')
    );

    document.body.classList.add('non-scrollable');

    docCookies.setItem(EXIT_INTENT_COOKIE_NAME, true, 0);

    // send data layer event when exit intent popup is shown
    sendDataLayerEvent('exitIntentPopupShow');
  }
};

jQuery(document).ready(function () {
  if (!docCookies.getItem(EXIT_INTENT_COOKIE_NAME)) {
    setTimeout(() => {
      document.addEventListener('mouseout', onMouseEvent);
      document.addEventListener('keydown', onExit);
      document.querySelector('.exit-modal').addEventListener('click', onExit);
    }, 0);
  }
});
